import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mergeProps as $cE0pI$mergeProps, filterDOMProps as $cE0pI$filterDOMProps, chain as $cE0pI$chain } from "@react-aria/utils";
import { useFocusable as $cE0pI$useFocusable } from "@react-aria/focus";
import { usePress as $cE0pI$usePress } from "@react-aria/interactions";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
  var _props$elementType = props.elementType,
    elementType = _props$elementType === void 0 ? "button" : _props$elementType,
    isDisabled = props.isDisabled,
    onPress = props.onPress,
    onPressStart = props.onPressStart,
    onPressEnd = props.onPressEnd,
    onPressChange = props.onPressChange,
    // @ts-ignore - undocumented
    preventFocusOnPress = props.preventFocusOnPress,
    // @ts-ignore - undocumented
    allowFocusWhenDisabled = props.allowFocusWhenDisabled,
    deprecatedOnClick = props.onClick,
    href = props.href,
    target = props.target,
    rel = props.rel,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type;
  var additionalProps;
  if (elementType === "button") additionalProps = {
    type: type,
    disabled: isDisabled
  };else additionalProps = {
    role: "button",
    tabIndex: isDisabled ? undefined : 0,
    href: elementType === "a" && isDisabled ? undefined : href,
    target: elementType === "a" ? target : undefined,
    type: elementType === "input" ? type : undefined,
    disabled: elementType === "input" ? isDisabled : undefined,
    "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
    rel: elementType === "a" ? rel : undefined
  };
  var _ref = (0, $cE0pI$usePress)({
      onPressStart: onPressStart,
      onPressEnd: onPressEnd,
      onPressChange: onPressChange,
      onPress: onPress,
      isDisabled: isDisabled,
      preventFocusOnPress: preventFocusOnPress,
      ref: ref
    }),
    pressProps = _ref.pressProps,
    isPressed = _ref.isPressed;
  var _ref2 = (0, $cE0pI$useFocusable)(props, ref),
    focusableProps = _ref2.focusableProps;
  if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
  var buttonProps = (0, $cE0pI$mergeProps)(focusableProps, pressProps, (0, $cE0pI$filterDOMProps)(props, {
    labelable: true
  }));
  return {
    isPressed: isPressed,
    buttonProps: (0, $cE0pI$mergeProps)(additionalProps, buttonProps, {
      "aria-haspopup": props["aria-haspopup"],
      "aria-expanded": props["aria-expanded"],
      "aria-controls": props["aria-controls"],
      "aria-pressed": props["aria-pressed"],
      onClick: function onClick(e) {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn("onClick is deprecated, please use onPress");
        }
      }
    })
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $55f54f7887471b58$export$51e84d46ca0bc451(props, state, ref) {
  var isSelected = state.isSelected;
  var _ref3 = (0, $701a24aa0da5b062$export$ea18c227d4417cc3)(_objectSpread(_objectSpread({}, props), {}, {
      onPress: (0, $cE0pI$chain)(state.toggle, props.onPress)
    }), ref),
    isPressed = _ref3.isPressed,
    buttonProps = _ref3.buttonProps;
  return {
    isPressed: isPressed,
    buttonProps: (0, $cE0pI$mergeProps)(buttonProps, {
      "aria-pressed": isSelected
    })
  };
}
export { $701a24aa0da5b062$export$ea18c227d4417cc3 as useButton, $55f54f7887471b58$export$51e84d46ca0bc451 as useToggleButton };